/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_HomeInputs */

const ja_playdata_nav_home = /** @type {(inputs: Playdata_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA ホーム`)
};

const en_playdata_nav_home = /** @type {(inputs: Playdata_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA home`)
};

/**
* | output |
* | --- |
* | "PLAYDATA home" |
*
* @param {Playdata_Nav_HomeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_nav_home = /** @type {((inputs?: Playdata_Nav_HomeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_HomeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_home(inputs)
	return en_playdata_nav_home(inputs)
});